module.exports = __webpack_public_path__ + "static/media/WBN_TIP.5dd73860.png";